import { auth, db } from "../services/firebase";
import firebase from "firebase/app";
import lsencryption from "../services/lsencryption";

export function signup(email, password) {
  return auth().createUserWithEmailAndPassword(email, password);
}

export function signin(email, password) {
  return auth().signInWithEmailAndPassword(email, password);
}

export function signInAnonymously() {
  return auth().signInAnonymously();
}

export function signInWithGoogle() {
  const provider = new auth.GoogleAuthProvider();
  return auth().signInWithPopup(provider);
}

export function signInWithGitHub() {
  const provider = new auth.GithubAuthProvider();
  return auth().signInWithPopup(provider);
}

export function logout() {
  return auth().signOut();
}

export function logError(params) {
  // Get browser name and version using regular expression
  var userAgent = navigator.userAgent;
  var browserName, browserVersion;

  if (/edg/i.test(userAgent)) {
    browserName = "Microsoft Edge";
    browserVersion = userAgent.match(/edg\/([\d.]+)/i)[1];
  } else if (/chrome/i.test(userAgent)) {
    browserName = "Google Chrome";
    browserVersion = userAgent.match(/chrome\/([\d.]+)/i)[1];
  } else if (/firefox/i.test(userAgent)) {
    browserName = "Mozilla Firefox";
    browserVersion = userAgent.match(/firefox\/(\d+)/i)[1];
  } else if (/safari/i.test(userAgent)) {
    browserName = "Apple Safari";
    browserVersion = userAgent.match(/version\/(\d+)/i)[1];
  } else if (/trident/i.test(userAgent)) {
    browserName = "Internet Explorer";
    browserVersion = userAgent.match(/rv:(\d+)/i)[1];
  } else if (/opera|opr/i.test(userAgent)) {
    browserName = "Opera";
    browserVersion = userAgent.match(/(?:opera|opr)\/(\d+)/i)[1];
  } else {
    browserName = "Unknown";
    browserVersion = "Unknown";
  }

  // let oParam = JSON.parse(lsencryption.get("community"));
  // const userInfoId = oParam.userId;
  // let fbRoom = oParam.communityId + "/dashboardexception";
  // let error = params?.error;
  // let userId = userInfoId ? userInfoId : "";
  // if (params.error && params.error.stack) {
  //   error = params.error.stack;
  // }
  // let data = {
  //   userid: userId,
  //   component: params.component || "",
  //   method: params.method || "",
  //   error: error || "",
  //   version: browserVersion,
  //   platform: browserName,
  //   timestamp: firebase.database.ServerValue.TIMESTAMP || Date.now(),
  // };
  // var newPostKey = db.ref().child(fbRoom).push().key;
  // data.msgid = newPostKey;
  // var updates = {};
  // updates[fbRoom + "/" + newPostKey] = data;
  // console.log("updates", updates);
  // db.ref().update(updates);
}
